<template>
  <div class="school-data">
    <div class="school-data__header">
      <div class="school-data__header__left">
        <h1>Vikartimer ift. Fraværstyper</h1>
      </div>
      <div class="school-data__header__right">
        <Datepickerrange
          :startdate="startDate"
          :enddate="endDate"
          @startchanged="setStartDate"
          @endchanged="setEndDate">
        </Datepickerrange>
        <button class="bttn submit-button" @click="readEvents">Søg</button>
      </div>
    </div>
    <h2 class="text-explainer" v-if="!isReadEventsClick">Vælg datoer og klik "Søg"</h2>
    <div class="loader-container" v-if="isLoading">
      <Loader></Loader>
      <h4>Henter lektioner fra en længere periode - det kan tage et par minutter</h4>
    </div>
    <template v-if="isReadEventsClick && !isLoading">
      <h2 class="text-explainer" v-if="subEventsWithAbsenceType.length < 1">Der er ingen vikartimer i perioden</h2>
      <table v-for="(absenceType, prop) in sortedAbsenceTypesWithLessons" class="d-acc-body-table"
             :class="{'d-acc-body-table--open': absenceType['isOpen'] }">
        <thead class="d-acc-body-table__first__header" @click="setActiveAcc(prop, absenceType)">
        <tr>
          <th colspan="3">{{ prop }}: {{ absenceType['formattedDuration'] }}</th>
        </tr>
        </thead>
        <thead class="d-acc-body-table__second__header" v-if="theActiveAcc === prop">
        <tr>
          <th v-for="column in sortColumns" :key="column.key"
              class="th-sorter"
              :class="{'th-sorter--active': sortKey === column.key}"
              @click="setSortKey(column.key)">
            {{ column.label }}
            <span v-if="sortKey === column.key">{{ sortOrder === 1 ? '▲' : '▼' }}</span>
          </th>
        </tr>
        </thead>
        <tbody v-if="theActiveAcc === prop">
        <tr v-for="lesson in sortLessons(absenceType['lessons'])" :key="lesson.id">
          <td>{{ lesson.vTimestamp }}, {{ lesson.title }}, {{lesson.vKlasses}}</td>
          <td>{{ lesson.substitute }}</td>
          <td>{{ lesson.substituteFor }}</td>
        </tr>
        </tbody>
      </table>
    </template>
  </div>
</template>

<script>
import ChangeSchoolYear from '../School/ChangeSchoolYear'
import Loader from '../common/Loader'
import docendo from '../../docendo'
import Datepickerrange from '../datepicker/DatePickerRange'
import Moment from 'moment'
import {extendMoment} from 'moment-range'

var moment = extendMoment(Moment)
export default {
  components: {Datepickerrange, Loader, ChangeSchoolYear},
  data () {
    return {
      events: [],
      subEventsWithAbsenceType: [],
      absenceTypesWithLessons: {},
      absenceEventsInHash: {},
      sortedAbsenceTypesWithLessons: {},
      isLoading: false,
      startDate: moment(),
      endDate: moment().add(7, 'days'),
      absenceEvents: [],
      theActiveAcc: '',
      isReadEventsClick: false,
      sortKey: 'start',
      sortOrder: 1,
      sortColumns: [
        {key: 'start', label: 'Dato'},
        {key: 'substitute', label: 'Vikar'},
        {key: 'substituteFor', label: 'Vikar for'}
      ]
    }
  },
  computed: {
    locale () {
      return this.$store.getters.locale
    },
    schoolId () {
      return this.$route.params.school_id * 1
    },
    user () {
      return this.$store.state.user
    },
    calendars () {
      return this.$store.state.calendars
    },
    isLoadingSchoolCalenders () {
      return this.$store.state.isLoadingSchoolCalenders
    },
    filteredCalendars () {
      return this.$store.getters.userCalendars
    },
    allUsersInCalIdHash () {
      return this.$store.getters.allUsersInCalIdHash
    },
    allUsersInHash () {
      return this.$store.getters.allUsersInHash
    }
  },
  watch: {
    user () {
      this.$store.dispatch('getSchoolCalendars', this.schoolId)
    }
  },
  methods: {
    setAbsenceEventsInHash () {
      this.absenceEventsInHash = {}
      this.absenceEvents.forEach((event, idx) => {
        const calId = this.allUsersInCalIdHash[event.calendar_id] ? this.allUsersInCalIdHash[event.calendar_id].id : event.calendar_id
        if (!this.absenceEventsInHash[calId]) {
          this.absenceEventsInHash[calId] = [event]
        } else {
          this.absenceEventsInHash[calId].push(event)
        }
      })
    },
    setSubEventsWithAbsenceType () {
      this.subEventsWithAbsenceType = []
      moment.locale(this.locale)
      this.events.forEach(lesson => {
        lesson.calendars.forEach(cal => {
          if (cal.substitute) {
            let subLesson = {
              id: lesson.event_id + '_' + cal.calendar_id,
              title: lesson.title,
              start: lesson.start,
              vTimestamp: moment(lesson.start).format('lll') + ' - ' + moment(lesson.end).format('LT'),
              vKlasses: lesson.calendars.filter(cal => cal.calendar_type === 'klass').map(cal => cal.name).join(' ,'),
              end: lesson.end,
              substitute: this.allUsersInCalIdHash[cal.calendar_id] ? this.allUsersInCalIdHash[cal.calendar_id].name : cal.calendar_id,
              substituteCalId: cal.calendar_id,
              minutes: cal.minutes,
              substituteFor: this.allUsersInHash[cal.substitute] ? this.allUsersInHash[cal.substitute].name : cal.substitute,
              absenceOverlapping: [],
              absenceTitle: 'Ukendt fraværsårsag'
            }
            if (this.absenceEventsInHash[cal.substitute]) {
              subLesson.absenceOverlapping = this.getEventsWithinDateTimes(this.absenceEventsInHash[cal.substitute], lesson.start, lesson.end)
            }
            if (subLesson.absenceOverlapping.length === 1) {
              subLesson.absenceTitle = subLesson.absenceOverlapping[0].title
            }
            if (subLesson.absenceOverlapping.length > 1) {
              subLesson.absenceTitle = 'Multiple'
            }
            this.subEventsWithAbsenceType.push(subLesson)
          }
        })
      })
      this.setAbsenceTypesWithLessons()
    },
    setAbsenceTypesWithLessons () {
      this.absenceTypesWithLessons = {}
      this.subEventsWithAbsenceType.forEach(lesson => {
        if (this.absenceTypesWithLessons[lesson.absenceTitle]) {
          this.absenceTypesWithLessons[lesson.absenceTitle]['minutes'] = this.absenceTypesWithLessons[lesson.absenceTitle]['minutes'] + (lesson.minutes * 1)
          this.absenceTypesWithLessons[lesson.absenceTitle]['lessons'].push(lesson)
        } else {
          this.absenceTypesWithLessons[lesson.absenceTitle] = {minutes: (lesson.minutes * 1), lessons: [lesson], type: lesson.absenceTitle, isOpen: false}
        }
      })
      this.setSortedAbsenceTypesWithLessons()
    },
    setSortedAbsenceTypesWithLessons () {
      this.sortedAbsenceTypesWithLessons = {}
      // Sort the absence types based on some criteria (e.g., title)
      const sortedKeys = Object.keys(this.absenceTypesWithLessons).sort((a, b) => {
        const minutesA = this.absenceTypesWithLessons[a].minutes
        const minutesB = this.absenceTypesWithLessons[b].minutes
        return minutesB - minutesA
      })
      // Populate the sorted absence types into the new object
      sortedKeys.forEach(key => {
        this.sortedAbsenceTypesWithLessons[key] = {
          ...this.absenceTypesWithLessons[key],
          formattedDuration: this.formatDuration(this.absenceTypesWithLessons[key].minutes)
        }
      })
    },
    formatDuration (minutes) {
      const hours = Math.floor(minutes / 60)
      const remainingMinutes = (minutes % 60).toFixed(0)
      return `${hours} timer ${remainingMinutes} min`
    },
    setSortKey (key) {
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder * -1
      } else {
        this.sortKey = key
        this.sortOrder = 1
      }
    },
    sortLessons (lessons) {
      const key = this.sortKey
      const order = this.sortOrder
      return [...lessons].sort((a, b) => {
        let result
        if (key === 'start') {
          result = moment(a.start).valueOf() - moment(b.start).valueOf()
        } else {
          result = String(a[key] || '').localeCompare(String(b[key] || ''), this.locale)
        }
        if (result === 0 && key !== 'start') {
          result = moment(a.start).valueOf() - moment(b.start).valueOf()
        }
        return result * order
      })
    },
    setActiveAcc (prop) {
      if (this.theActiveAcc === prop) {
        this.theActiveAcc = ''
      } else {
        this.theActiveAcc = prop
      }
    },
    getEventsWithinDateTimes (events, start, end) {
      // er eventet indenfor fraværets start og slut
      return events.filter(event => {
        const eventStart = moment(start).startOf('day')
        const eventEnd = moment(end).endOf('day')
        const absenceStart = moment(event.start)
        const absenceEnd = moment(event.end)
        // find the absence hvor eventet er within
        const range1 = moment.range(eventStart, eventEnd)
        const range2 = moment.range(absenceStart, absenceEnd)
        return range1.intersect(range2)
      })
    },
    resetDates () {
      this.setDates(this.schoolYearStartDate, this.schoolYearEndDate)
    },
    setStartDate (date) {
      this.setDates(date, null)
    },
    setEndDate (date) {
      this.setDates(null, date)
    },
    setDates (start, end) {
      if (start) {
        this.startDate = start
      }
      if (end) {
        this.endDate = end
      }
    },
    readEvents () {
      this.theActiveAcc = ''
      this.isReadEventsClick = true
      this.isLoading = true
      let start = moment(this.startDate).format('YYYY-MM-DD')
      let end = moment(this.endDate).endOf('day')
      const calendarIds = this.filteredCalendars.map(calendar => calendar.id)
      docendo.calendarEvents2(calendarIds, start, end, null,
        success => {
          this.events = JSON.parse(success).filter(event => event.school_id === this.schoolId)
          this.absenceEvents = this.events.filter(event => event.event_type === 'absence' && event.school_id === this.schoolId)
          this.isLoading = false
          this.setAbsenceEventsInHash()
          this.setSubEventsWithAbsenceType()
        }, failure => {
          console.log('failure', failure)
        })
    },
    compareDates (firstDate, secondDate) {
      return moment(firstDate).format('YYYY-MM-DD') === moment(secondDate).format('YYYY-MM-DD')
    }
  },
  beforeMount () {
    this.$store.dispatch('getUsersFromSchoolId', this.schoolId)
    this.$store.dispatch('getUser')
  }
}
</script>


<style scoped>
@import "../../assets/css/variables.css";

.school-data {
  margin: 1rem;
}

.school-data__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1440px;
  min-width: 1100px;
}

.school-data__header__left {
  display: flex;
  align-items: center;
}

.school-data__header h1 {
  margin-right: 1rem;
}

.loader-container {
  text-align: center;
}

.school-data__header__right {
  display: flex;
  align-items: center;
}


.d-link {
  color: var(--blue);
  cursor: pointer;
  margin-right: 1rem;
}

.d-link:hover {
  text-decoration: underline;
}


.d-table {
  width: 100%;
  border: 1px solid #d8d8d8;
  border-collapse: collapse;
  border-radius: 4px;
}

.d-table thead {
  border-bottom: 1px solid #d8d8d8;
  background: #f6f9fc;
  color: #728195;
  text-transform: uppercase;
  border-radius: 4px;
  font-size: 11px;
}

.d-table thead th {
  padding: 0.5rem 1rem;
  text-align: left;
}

.d-table tbody tr {
  width: 100%;
  background: #f9fafb;
  border-bottom: 1px solid #e3e8ee;
}

.d-table tbody tr:nth-child(odd) {
  background: #ffffff;
}

.d-table tbody tr:hover {
  background: aliceblue;
}

.d-table tbody tr td {
  padding: 0.5rem 1rem;
  text-align: left;
}

.hidden-toggler {
  cursor: pointer;
  padding: 0.25rem 1rem;
}

.hidden-toggler > span {
  margin-right: 0.5rem;
}

.d-table thead tr th:first-child,
.d-table tbody tr td:first-child {
  max-width: 50px;
  width: 50px;
}

.toggler {
  border-bottom: 1px solid #d8d8d8;
  background: #eef0f5 !important;
  color: #728195;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 11px;
}

.toggler td {
  padding: 0;
}

.d-acc {
  border: 1px solid #dddddd;
  border-radius: 4px;
}

.d-acc-body-table {
  background-color: #fff;
  width: 100%;
  border: 1px solid #e2e8f0;
  border-collapse: collapse;
  max-width: 1200px;
}

.d-acc-body-table thead {
  text-align: left;
  font-size: 14px;
  border: 1px solid #e2e8f0;
}

.d-acc-body-table thead th {
  padding: 0.5rem 1rem;
}

.d-acc > li:first-child {
  border-radius: 4px 4px 0 0;
}

.d-acc > li:last-child {
  border-radius: 4px 4px 0 0;
}

.d-acc-body-table th,
.d-acc-body-table td {
  padding: 0.25rem 1rem;
}

.d-acc-body-table tr:nth-child(2n) {
  background-color: #f9fafb;
}

.d-acc-body-table thead.d-acc-body-table__second__header {
  text-transform: uppercase;
  font-weight: 700;
  text-align: left;
  background: #f6f9fc;
  color: #8898aa;
  font-size: 10px;
}

.d-acc-body-table thead.d-acc-body-table__second__header th {
  padding: 0 1rem;
}

.d-acc-body-table td:nth-child(2) {
  width: 50%;
}

.d-acc-body-table__first__header {
  position: relative;
  cursor: pointer;
}

.d-acc-body-table__first__header tr th:first-child {
  position: relative;
  padding-left: 40px;
}

.d-acc-body-table__first__header tr th:before {
  content: "\edc2";
  position: absolute;
  top: 10px;
  left: 10px;
  font-family: 'icomoon' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.d-acc-body-table--open .d-acc-body-table__first__header tr th:before {
  content: "\edba";
}

.d-acc-body-table__first__header:hover {
  background-color: aliceblue;
}

.th-sorter {
  cursor: pointer;
  user-select: none;
}

.th-sorter:hover,
.th-sorter.th-sorter--active {
  color: var(--dark-blue);
}

.submit-button {
  width: 75px;
  height: 38px;
  margin-left: 1rem;
}
</style>



// WEBPACK FOOTER //
// SchoolDataSubsAbsenceType.vue?59b19cb4